// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3651) return "static/chunks/3651-29def054e6733fdc.js";
	if (chunkId === 3281) return "static/chunks/3281-952c153b2e9eaaba.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"1297":"Polaris-i18n","6443":"Bundle-i18n"}[chunkId] || chunkId) + "." + {"1297":"a9e350d8279663d5","3777":"9c42432c32c21471","6320":"9d6d093a98ba8d6e","6443":"4a75c8dcf686a3b4","7176":"622f27e673b5dec8"}[chunkId] + ".js";
};